import { Observable } from 'rxjs';
import { IApiResponse } from '@web/shared-types';
import { AppConfigService } from '../../../app-config.service';
import { inject } from '@angular/core';
import { RestCallBuilder } from '../../../../builder/rest/rest-call.builder';
import { IGetGateway } from '../../gateways';
import { ITariffRelationLocation } from '@web/dtos';
import { IOriginRequest } from '../origins/origins.gateway';

export interface IDestinationRequest extends IOriginRequest {
  origin: string;
}

export class DestinationsGateway implements IGetGateway<
  IDestinationRequest,
  IApiResponse<ITariffRelationLocation[]>
> {
  private readonly restCallBuilder: RestCallBuilder<ITariffRelationLocation[]> =
    new RestCallBuilder<ITariffRelationLocation[]>([]);
  private readonly configService: AppConfigService = inject(AppConfigService);

  get(
    request: IDestinationRequest
  ): Observable<IApiResponse<ITariffRelationLocation[]>> {
    return this.restCallBuilder
      .getExternal(
        this.configService.get().general.tariffUrl + '/relation/destinations',
        {
          serviceAreaId: request.serviceAreaId,
          maxResults: request.loadAllStops ? '' : request.maxResults,
          origin: request.origin,
          name: request.name || '',
        }
      )
      .handleMessages()
      .build();
  }
}
